export const martaAndracka = {
    'firstName': 'Marta',
    'lastName': 'Andracka',
    'profession': 'Psychiatra',
    'avatar': 'marta-andracka.webp',
    'slug': 'psychiatra-marta-andracka',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'adult'],
        ['psychiatry', 'elder']
    ]
}